export enum SummarySectionNames {
	SITE_LOGS = 'Site Logs',
	TOTAL_PAID = 'Total Paid',
	BREAKS = 'Breaks',
	AUTO_CHECK = 'Auto Check',
}
